export const MAX_INTEGER = 2147483647;
